"use client"

import { useState } from "react"
import { cn } from "@/lib/tailwind-utils"
import { usePathname } from "next/navigation"
import { FaWhatsapp, FaHeadset, FaTimes, FaCircle } from "react-icons/fa"

const HelpUs = () => {
  const pathname = usePathname()
  const [isOpen, setIsOpen] = useState(false)

  const whatsappContacts = [
    {
      name: "Pelayanan Pelatihan dan Sertifikasi",
      value: "6285229654056",
      desc: "Jam Kerja: Senin - Jumat (07.30 - 16.00)",
      status: "Online"
    },
    {
      name: "Pelayanan Pelatihan dan Sertifikasi (Bpk Ibnu)",
      value: "6281356001794",
      desc: "Jam Kerja: Senin - Jumat (07.30 - 16.00)",
      status: "Online"
    },
    {
      name: "Layanan Kemitraan & Kerjasama",
      value: "628561747815",
      desc: "Pemasaran & Kerjasama Antar Lembaga",
      status: "Online"
    },
    {
      name: "Layanan Pesan Penginapan (Ibu Nurhidayah)",
      value: "6285716666564",
      desc: "Booking Kamar Mess & Penginapan",
      status: "Online"
    },
    {
      name: "Humas Bppp Tegal (Ibu Ade)",
      value: "6281326906109",
      desc: "Kritik, Saran & Masukan Layanan",
      status: "Online"
    },
    {
      name: "Layanan Pengaduan Masyarakat",
      value: "62895324390866",
      desc: "Bpk Yuda",
      status: "Online"
    }
  ]

  return (
    <div
      className={cn(
        "flex flex-col gap-y-3 fixed bottom-[20px] z-50 md:bottom-5 md:p-3 transition-all duration-300",
        {
          "left-3 items-start": pathname?.includes("daftar"),
          "right-3 items-end": !pathname?.includes("daftar"),
        }
      )}
    >
      {/* Premium WhatsApp Chat Pop-up Panel */}
      {isOpen && (
        <div 
          className={cn(
            "w-[340px] md:w-[370px] rounded-[24px] overflow-hidden shadow-[0_25px_60px_rgba(0,0,0,0.18)] border border-slate-100 bg-white mb-3 transition-all duration-500 animate-in fade-in slide-in-from-bottom-6 zoom-in-95",
            {
              "origin-bottom-left": pathname?.includes("daftar"),
              "origin-bottom-right": !pathname?.includes("daftar"),
            }
          )}
        >
          {/* Header Panel with Premium Gradient Mesh and Glow */}
          <div className="bg-gradient-to-tr from-[#0b8a47] via-[#09A155] to-[#2E8B57] p-6 text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-10" style={{backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`, backgroundSize: '12px 12px'}} />
            <div className="absolute -top-10 -left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl pointer-events-none" />
            <div className="absolute -right-6 -bottom-6 w-24 h-24 bg-white/10 rounded-full blur-xl pointer-events-none" />
            
            <button 
              onClick={() => setIsOpen(false)}
              className="absolute top-4 right-4 text-white/80 hover:text-white hover:rotate-90 transition-all duration-300 p-2 rounded-full hover:bg-white/10"
            >
              <FaTimes className="w-3.5 h-3.5" />
            </button>
            
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center text-white shrink-0 shadow-lg">
                <FaWhatsapp className="w-7 h-7 text-white" />
              </div>
              <div className="pr-4">
                <h3 className="text-base font-black tracking-wide leading-tight">Hubungi Kami via WhatsApp</h3>
                <p className="text-emerald-50/90 text-xs mt-1 font-medium leading-relaxed">
                  Silakan pilih salah satu layanan resmi kami di bawah ini untuk memulai percakapan.
                </p>
              </div>
            </div>
          </div>

          {/* List of Contacts with Custom Smooth Rounded Scrollbar */}
          <div className="max-h-[350px] overflow-y-auto p-4 bg-[#F8FAFC] space-y-3 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-300/60 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-slate-400/80 [&::-webkit-scrollbar-thumb]:transition-colors">
            {whatsappContacts.map((contact, idx) => (
              <a
                key={idx}
                href={`https://wa.me/${contact.value}?text=Hallo,%20saya%20membutuhkan%20informasi/bantuan%20terkait%20${encodeURIComponent(contact.name)}.`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-3 p-3.5 rounded-2xl bg-white hover:bg-emerald-50/10 border border-slate-100/80 hover:border-emerald-100 hover:-translate-y-[2px] transition-all duration-300 group/row cursor-pointer shadow-sm hover:shadow-md"
              >
                <div className="flex items-center gap-3.5 min-w-0">
                  {/* Left: Premium Official WhatsApp Icon Bubble */}
                  <div className="w-11 h-11 rounded-full bg-emerald-50 border border-emerald-100/60 flex items-center justify-center shrink-0 shadow-sm group-hover/row:scale-105 transition-all duration-300">
                    <FaWhatsapp className="text-[#09A155] w-6 h-6" />
                  </div>
                  
                  <div className="min-w-0 text-left space-y-1">
                    <h4 className="text-slate-800 font-bold text-xs tracking-wide group-hover/row:text-[#09A155] transition-colors leading-tight">
                      {contact.name}
                    </h4>
                    <p className="text-[10px] text-slate-400 font-bold leading-normal flex items-center gap-1.5 flex-wrap">
                      <span className="text-[9px] font-black text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full flex items-center gap-1 shrink-0">
                        <FaCircle className="w-1.5 h-1.5 text-emerald-500 animate-pulse" />
                        {contact.status}
                      </span>
                      <span className="font-semibold text-slate-400 leading-normal">{contact.desc}</span>
                    </p>
                  </div>
                </div>
                
                {/* Right: Modern Outlined WhatsApp Bubble */}
                <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center shrink-0 group-hover/row:bg-[#09A155] transition-all duration-300 border border-slate-100/50">
                  <FaWhatsapp className="w-4 h-4 text-[#09A155] group-hover/row:text-white transition-colors" />
                </div>
              </a>
            ))}
          </div>
        </div>
      )}

      {/* Floating Buttons */}
      <div className="flex flex-col gap-y-2.5 items-end">
        {!isOpen && (
          <p className="text-white hidden md:block bg-color-4 text-center px-4 py-2 text-txt10_14 md:text-txt14_20 rounded-xl border-white border shadow-xl animate-bounce font-bold tracking-wide">
            Hallo, BPPP Tegal <span className="block text-[11px] font-medium opacity-90 mt-0.5">Saya perlu bantuan !</span>
          </p>
        )}
        <div className="flex gap-2.5">
          {/* Support Headset Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={cn(
              "w-12 h-12 flex items-center justify-center rounded-2xl border-2 border-white text-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300 hover:scale-110 active:scale-95",
              isOpen ? "bg-slate-700 hover:bg-slate-600" : "bg-baseBlue2 hover:bg-blue-600"
            )}
          >
            {isOpen ? <FaTimes className="w-5 h-5" /> : <FaHeadset className="w-5 h-5" />}
          </button>
          
          {/* WhatsApp Toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={cn(
              "w-12 h-12 flex items-center justify-center rounded-2xl border-2 border-white text-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300 hover:scale-110 active:scale-95 relative",
              isOpen ? "bg-slate-700 hover:bg-slate-600" : "bg-[#09A155] hover:bg-[#0BA360]"
            )}
          >
            {/* Glowing outer ring when closed */}
            {!isOpen && (
              <span className="absolute inset-0 rounded-2xl bg-[#09A155] animate-ping opacity-25 scale-110 pointer-events-none" />
            )}
            <FaWhatsapp className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default HelpUs




